import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import store from "./store/store";
import "../static/css/main.css";


Vue.prototype.$axios = axios;
Vue.prototype.$store = store;
Vue.config.productionTip = false;


Vue.prototype.bus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
